export const GetBinaryDataFromCapturedImage = (capturedImage: string) => {
    return capturedImage.replace('data:image/png;base64,', '');
}

export const GetBinaryDataFromCapturedAudio = (capturedImage: string) => {
  return capturedImage.replace('data:audio/wav;base64,', '');
}

